import React from 'react';
import { Image, Text } from 'components';

const OrderItem = ({
  src,
  placeName,
  productName,
  subName,
  productData,
  onClick,
  screenSize,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Image src={src} alt={productName} width={90} height={111} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'start',
          marginLeft: 24,
        }}
      >
        <Text
          style={{
            fontSize: 14,
            fontWeight: 700,
            marginBottom: 4,
            width: 'fit-content',
            borderBottom: '1px solid var(--black-color)',
          }}
        >
          {placeName}
        </Text>
        <Text
          className={'product_name'}
          style={{
            fontSize: screenSize >= 768 ? 18 : 15,
            fontWeight: 700,
            marginBottom: subName ? 2 : 8,
            wordBreak: 'keep-all',
            webkitLineClamp: 'unset',
          }}
        >
          {productName}
        </Text>
        {subName ? (
          <Text
            className={'product_subname'}
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: 'var(--dark-gray-color)',
              marginBottom: 2,
            }}
          >
            {subName}
          </Text>
        ) : null}
        <Text
          className={'product_data'}
          style={{
            fontSize: 14,
            fontWeight: 400,
            color: 'var(--dark-gray-color)',
          }}
        >
          {productData}
        </Text>
      </div>
    </div>
  );
};

export default OrderItem;
